import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { Commons } from 'components';
import { TableForm, Pagination } from 'components/Commons';
import cm from 'helpers/commons';

const propTypes = {};

const defaultProps = {};

class AuthStaffList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { authStaffList, fn } = this.props;

    let pagination_page = 1;
    let pagination_pagerow = 0;
    let pagination_totalcount = 0;

    const header = [
      { data: 'ID', textAlign: 'left' },
      { data: '이름', textAlign: 'left' },
      { data: '범위', textAlign: 'left' },
      { data: '권한', textAlign: 'left' },
      { data: '수정일', textAlign: 'left' },
      { data: '', textAlign: 'left' },
      { data: '', textAlign: 'left' }
    ];

    const main = cm.tableHeaderList(header, 2, false, 'default');

    const tabledata = {
      header: {
        main
      },
      body: {
        message: '내역이 존재하지 않습니다.',
        main: null
      }
    };

    if (authStaffList && authStaffList.data) {
      const { page, pageRow, total, content } = authStaffList.data;

      pagination_page = page;
      pagination_pagerow = pageRow;
      pagination_totalcount = total;

      tabledata.body.main = content.map((item) => {
        let auth = '';
        if (item.auth.type === 'COMPANY') {
          auth = '회사전체';
        } else if (item.auth.type === 'DIVISION') {
          auth = cm.divisionNavi(item.auth.organization);
        }

        let obj = {
          row: [
            { data: item.signId, textAlign: 'left' },
            { data: item.name, textAlign: 'left' },
            { data: auth, textAlign: 'left' },
            { data: item.preset.name, textAlign: 'left' },
            {
              data: `${cm.yyyyMMdd(new Date(item.auth.regDate))} ${cm.hhmmss(new Date(item.auth.regDate))}`,
              textAlign: 'left'
            },
            {
              data: (
                <Button inverted color="black" style={{ width: '100px' }} onClick={(e) => fn.modStaffPage(item)}>
                  변경
                </Button>
              ),
              textAlign: 'left',
              width: 100
            },
            {
              data: (
                <Button
                  inverted
                  color="red"
                  style={{ width: '100px' }}
                  onClick={(e) => fn.confirmOpen(true, null, item)}
                >
                  삭제
                </Button>
              ),
              textAlign: 'left',
              width: 100
            }
          ]
        };

        obj = cm.defalutTableStaffDivisionSet(obj.row, 2, item.orgCode);

        return obj;
      });
    }

    return (
      <div>
        {authStaffList ? (
          <div>
            <div className="table-box">
              {/* <Commons.TableForm
                  tabledata={tabledata}
                /> */}
              <TableForm selectable="true" tabledata={tabledata} />
            </div>
            <div className="table-paging">
              <Pagination
                page={pagination_page}
                pageRow={pagination_pagerow}
                pageBlock={10}
                totalCount={pagination_totalcount}
                pageClick={fn.pageClick}
              />
            </div>
          </div>
        ) : (
          <Commons.LoadingBar />
        )}
      </div>
    );
  }
}

AuthStaffList.propTypes = propTypes;
AuthStaffList.defaultProps = defaultProps;

AuthStaffList = connect(
  (state) => ({
    authStaffList: state.etc.authStaffList
  }),
  (dispatch) => ({})
)(AuthStaffList);

export default AuthStaffList;
